import React from 'react';

function FormMessage(props) {
    return (
        <section className="form-message animated fadeIn go">
            <div className="form-message__content">
                <div className="form-message__success-message">
                    <img src="/images/icons/other/icon_checklist-white.svg" alt="Ikona" />
                    <h5 className="headline-5 max-w-md">
                        {props.message}
                    </h5>
                </div>
                {props.children}
            </div>
        </section>
    );
}

export default FormMessage;
